import React, { useRef } from 'react';
import { useParams } from 'react-router-dom';
import SubPage from '#/common/components/SubPage';
import useAlertQuery from '../hooks/useAlertQuery';
import useNotFoundGuard from '#/common/hooks/useNotFoundGuard';
import RecordNotFound from '#/app/pages/errors/RecordNotFound';
import getFormTitle from '#/common/utils/getFormTitle';
import AlertRecordPreview from '../components/AlertRecordPreview';

export interface AlertParams {
  readonly id?: string;
}

const AlertPage: React.FC = () => {
  const { id } = useParams() as AlertParams;
  const alertQuery = useAlertQuery(id);
  const alert = alertQuery.data?.getAlert?.data;
  const isNotFound = useNotFoundGuard({ loading: alertQuery.loading, id, entity: alert });

  // Use a ref to store the initial updatedAt value to prevent form remount
  // on background refetches (cache-and-network).
  const formKeyRef = useRef<string | null>(null);
  if (alert && !formKeyRef.current) {
    formKeyRef.current = alert.updatedAt ?? alert.id ?? null;
  }

  const displayNumber = alert?.displayNumber;
  const title = getFormTitle(id, displayNumber, 'Exception');

  if (isNotFound) {
    return (
      <SubPage title={title} isLoading={false} showGoBackButton type="form">
        <RecordNotFound backUrl="/alerts" />
      </SubPage>
    );
  }

  return (
    <SubPage title={title} isLoading={alertQuery.loading} showGoBackButton type="form">
      {alert && (
        <AlertRecordPreview key={`alert-${id}-${formKeyRef.current}`} alert={alert || {}} />
      )}
    </SubPage>
  );
};

export default React.memo(AlertPage);
